// Mock data for BSQUARE CRM

export const mockLeads = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "TechCorp Inc",
    email: "sarah.johnson@techcorp.com",
    phone: "+1 (555) 123-4567",
    status: "New",
    source: "Website",
    value: "$50,000",
    createdDate: "2025-01-15",
    lastActivity: "2025-01-20"
  },
  {
    id: 2,
    name: "Michael Chen",
    company: "Innovation Labs",
    email: "m.chen@innovlabs.com",
    phone: "+1 (555) 987-6543",
    status: "Qualified",
    source: "Referral",
    value: "$75,000",
    createdDate: "2025-01-12",
    lastActivity: "2025-01-19"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    company: "Global Systems",
    email: "e.rodriguez@globalsys.com",
    phone: "+1 (555) 456-7890",
    status: "Contacted",
    source: "LinkedIn",
    value: "$125,000",
    createdDate: "2025-01-10",
    lastActivity: "2025-01-18"
  },
  {
    id: 4,
    name: "David Thompson",
    company: "StartupXYZ",
    email: "david@startupxyz.com",
    phone: "+1 (555) 321-0987",
    status: "Proposal",
    source: "Trade Show",
    value: "$30,000",
    createdDate: "2025-01-08",
    lastActivity: "2025-01-17"
  }
];

export const mockContacts = [
  {
    id: 1,
    name: "John Smith",
    company: "Acme Corporation",
    email: "john.smith@acme.com",
    phone: "+1 (555) 111-2222",
    position: "CEO",
    department: "Executive",
    lastContact: "2025-01-20",
    status: "Active"
  },
  {
    id: 2,
    name: "Lisa Wang",
    company: "Tech Innovations",
    email: "lisa.wang@techinno.com",
    phone: "+1 (555) 333-4444",
    position: "CTO",
    department: "Technology",
    lastContact: "2025-01-19",
    status: "Active"
  },
  {
    id: 3,
    name: "Robert Miller",
    company: "Enterprise Solutions",
    email: "r.miller@enterprise.com",
    phone: "+1 (555) 555-6666",
    position: "VP Sales",
    department: "Sales",
    lastContact: "2025-01-18",
    status: "Inactive"
  }
];

export const mockDeals = [
  {
    id: 1,
    name: "Enterprise Software License",
    account: "TechCorp Inc",
    stage: "Proposal",
    value: "$150,000",
    probability: "75%",
    expectedClose: "2025-02-15",
    owner: "John Doe",
    lastActivity: "2025-01-20"
  },
  {
    id: 2,
    name: "Cloud Migration Project",
    account: "Innovation Labs",
    stage: "Negotiation",
    value: "$300,000",
    probability: "90%",
    expectedClose: "2025-01-30",
    owner: "Jane Smith",
    lastActivity: "2025-01-19"
  },
  {
    id: 3,
    name: "Digital Transformation",
    account: "Global Systems",
    stage: "Qualification",
    value: "$500,000",
    probability: "50%",
    expectedClose: "2025-03-10",
    owner: "Mike Johnson",
    lastActivity: "2025-01-18"
  }
];

export const mockAccounts = [
  {
    id: 1,
    name: "TechCorp Inc",
    type: "Enterprise",
    industry: "Technology",
    revenue: "$50M - $100M",
    employees: "500-1000",
    phone: "+1 (555) 100-2000",
    website: "www.techcorp.com",
    owner: "John Doe",
    status: "Active"
  },
  {
    id: 2,
    name: "Innovation Labs",
    type: "Mid-Market",
    industry: "Research & Development",
    revenue: "$10M - $50M",
    employees: "100-500",
    phone: "+1 (555) 200-3000",
    website: "www.innovlabs.com",
    owner: "Jane Smith",
    status: "Active"
  },
  {
    id: 3,
    name: "Global Systems",
    type: "Enterprise",
    industry: "Manufacturing",
    revenue: "$100M+",
    employees: "1000+",
    phone: "+1 (555) 300-4000",
    website: "www.globalsys.com",
    owner: "Mike Johnson",
    status: "Prospect"
  }
];

export const mockSupportTickets = [
  {
    id: 1,
    ticketId: "TKT-001234",
    subject: "Login Issues with CRM System",
    description: "I'm unable to log into my CRM account. Getting 'Invalid credentials' error even with correct password. Please help resolve this issue.",
    customerName: "Sarah Johnson",
    customerEmail: "sarah.johnson@techcorp.com",
    customerPhone: "+1 (555) 123-4567",
    status: "Open",
    priority: "High",
    category: "Technical Issue",
    assignedTo: "Technical Support",
    createdAt: "2025-01-20",
    updatedAt: "2025-01-20",
    responses: [
      {
        id: 1,
        author: "Support Agent",
        message: "We've received your ticket and are investigating the login issue.",
        timestamp: "2025-01-20 10:30"
      }
    ]
  },
  {
    id: 2,
    ticketId: "TKT-001235",
    subject: "Feature Request - Export Contacts to Excel",
    description: "Would like to request a feature to export all contacts data to Excel format. This would be very helpful for reporting purposes.",
    customerName: "Michael Chen",
    customerEmail: "m.chen@innovlabs.com",
    customerPhone: "+1 (555) 987-6543",
    status: "In Progress",
    priority: "Medium",
    category: "Feature Request",
    assignedTo: "Product Team",
    createdAt: "2025-01-18",
    updatedAt: "2025-01-19",
    responses: [
      {
        id: 1,
        author: "Product Manager",
        message: "Thanks for the suggestion! We're evaluating this feature for our next release.",
        timestamp: "2025-01-19 14:20"
      }
    ]
  },
  {
    id: 3,
    ticketId: "TKT-001236",
    subject: "Billing Query - Invoice Discrepancy",
    description: "There seems to be a discrepancy in my latest invoice. The amount charged is higher than expected. Please review and clarify.",
    customerName: "Emily Rodriguez",
    customerEmail: "e.rodriguez@globalsys.com",
    customerPhone: "+1 (555) 456-7890",
    status: "Resolved",
    priority: "Medium",
    category: "Billing",
    assignedTo: "Billing Team",
    createdAt: "2025-01-15",
    updatedAt: "2025-01-17",
    responses: [
      {
        id: 1,
        author: "Billing Support",
        message: "We've reviewed your account and found the discrepancy. A corrected invoice will be sent shortly.",
        timestamp: "2025-01-17 11:45"
      }
    ]
  },
  {
    id: 4,
    ticketId: "TKT-001237",
    subject: "Data Import Issues",
    description: "Having trouble importing customer data from CSV file. The system shows error 'Invalid format' but the file seems correct.",
    customerName: "David Thompson",
    customerEmail: "david@startupxyz.com",
    customerPhone: "+1 (555) 321-0987",
    status: "Open",
    priority: "High",
    category: "Technical Issue",
    assignedTo: "Technical Support",
    createdAt: "2025-01-19",
    updatedAt: "2025-01-19",
    responses: []
  },
  {
    id: 5,
    ticketId: "TKT-001238",
    subject: "Account Upgrade Request",
    description: "I would like to upgrade my current plan to include more users and advanced features. Please provide pricing information.",
    customerName: "Lisa Wang",
    customerEmail: "lisa.wang@techinno.com",
    customerPhone: "+1 (555) 333-4444",
    status: "Closed",
    priority: "Low",
    category: "Account Issue",
    assignedTo: "Sales Team",
    createdAt: "2025-01-10",
    updatedAt: "2025-01-12",
    responses: [
      {
        id: 1,
        author: "Sales Representative",
        message: "Thank you for your interest! I've sent you detailed pricing information via email.",
        timestamp: "2025-01-12 16:30"
      }
    ]
  }
];

export const mockDashboardStats = {
  totalLeads: 156,
  totalContacts: 342,
  totalDeals: 28,
  totalRevenue: "$2,450,000",
  monthlyGrowth: {
    leads: 12,
    contacts: 8,
    deals: 15,
    revenue: 22
  },
  recentActivities: [
    {
      id: 1,
      type: "lead",
      action: "New lead created",
      description: "Sarah Johnson from TechCorp Inc",
      time: "2 hours ago"
    },
    {
      id: 2,
      type: "deal",
      action: "Deal updated",
      description: "Enterprise Software License moved to Proposal",
      time: "4 hours ago"
    },
    {
      id: 3,
      type: "contact",
      action: "Contact updated",
      description: "John Smith contact information updated",
      time: "6 hours ago"
    }
  ],
  salesFunnel: [
    { stage: "Leads", count: 156, value: "$1,200,000" },
    { stage: "Qualified", count: 89, value: "$850,000" },
    { stage: "Proposal", count: 45, value: "$650,000" },
    { stage: "Negotiation", count: 28, value: "$420,000" },
    { stage: "Closed Won", count: 15, value: "$280,000" }
  ]
};